import React from "react";
import styles from "../../components/Insurance/insurance-comp.module.scss";

const SmartHomeSuccess = ({
  goHome,
  close,
}: {
  goHome: () => void;
  close: () => void;
}) => {
  return (
    <div className={styles["save-cont"]}>
      <div className={styles["inner-cont"]}>
        <div
          className={styles["close-cont"]}
          role="button"
          onClick={() => close()}
        >
          <div className="icon-cancel"></div>
        </div>

        <span className={styles["save-quote-header"]}>Success!</span>
        <span className={styles["save-quote-text"]}>
        Thank you for submitting your smart home application. A member of our team will contact you shortly for installation and Logistics Price.
        </span>

        <span
          className={styles["save-home"]}
          role="button"
          onClick={() => goHome()}
        >
          Go Home
        </span>
      </div>
    </div>
  );
};

export default SmartHomeSuccess;
